import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import profileBg from '../../../assets/images/auth-one-bg.jpg';
import { alertSuccess, generateColor } from '../../../helpers/general';
import { useDispatch, useSelector } from 'react-redux';
import Address from './Address';
import UserDetails from './UserDetails';
import Journey from './Journey';
import TransactionTable from './Transactions/TransactionTable';
import Dashboard from './Dashboard/Dashboard';
import { getAllConfigs } from '../../../actions/promotion/generals';
import { getMemberDetail, listMembers } from '../../../actions/members/list';
import { If, Then } from 'react-if';
import { getRewardsMaster } from '../../../actions/rewards';
import RewardTransactionTable from '../../Reward/RewardTransactions/TransactionTable';
import Barcode from 'react-barcode';
import CountUp from 'react-countup';
import { formatDate } from '../../../helpers/formatDate';

/**
 *
 * @returns
 */
const Profile = () => {
  document.title = 'Profile';
  let params = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [fields, setFields] = useState([]);
  const [member, setMember] = useState({});
  const [configs, setSelectedConfig] = useState(null);
  const [rewards, setRewards] = useState([]);
  const [rewardTypeTabs, setRewardTypeTabs] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');

  const getConfigs = async () => {
    try {
      setIsLoading(true);
      const { data } = await getAllConfigs({
        configName: 'members',
        configEnv: process.env.NODE_ENV,
        pageOffset: Math?.max(0 - 1, 0),
        pageSize: 1000,
      });

      const res = await getRewardsMaster(data);
      setRewards(res?.data?.rewardTypes || []);

      setFields([...data]);
      const fieldConfigs = {};

      data.map((item) => {
        let fieldType = null;
        let isLoyaltyCardUniqueID = false;
        let isDisplayInProfile = false;

        item.values.forEach((value) => {
          if (value.fieldCode === 'fieldType') {
            fieldType = value.fieldValue;
          }
        });
        if (fieldType === 'OtherField') {
          item.values.forEach((value) => {
            if (value.fieldCode === 'isLoyaltyCardUniqueID') {
              if (!fieldConfigs['loyaltyCardNumbers']) {
                fieldConfigs['loyaltyCardNumbers'] = [];
              }
              isLoyaltyCardUniqueID = true;
            }
            if (value.fieldCode === 'displayInProfile') {
              if (!fieldConfigs['displayInProfile']) {
                fieldConfigs['displayInProfile'] = [];
              }
              isDisplayInProfile = true;
            }
          });
        }
        item.values.forEach((value) => {
          if (value.fieldCode === 'fieldId') {
            if (isDisplayInProfile) {
              fieldConfigs['displayInProfile'].push(value.fieldValue);
            }
            if (isLoyaltyCardUniqueID) {
              fieldConfigs['loyaltyCardNumbers'].push(value.fieldValue);
            }
            if (fieldType !== 'OtherField') {
              fieldConfigs[fieldType] = value.fieldValue;
            }
          }
        });
      });
      setSelectedConfig(fieldConfigs);
      console.log('fieldConfigs', fieldConfigs, data);
      const member = await getMemberDetail({ id: params.id });
      setMember(member);

      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getConfigs();
  }, []);

  //

  // form validation

  setTimeout(() => {
    setIsLoading(false);
  }, 3500);
  /**
   *
   * @param {*} tab
   */
  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    if (member?.rewards) {
      const rewardTabs = Object.keys(member?.rewards)?.map((key) => ({
        label: key?.replaceAll('_', ' '),
        id: member?.rewards?.[key]?.[member?.country]?.id,
        rewardId: member?.rewards?.[key]?.[member?.country]?.id,
        rewardTypeId: key,
      }));

      setRewardTypeTabs([...rewardTabs]);
    }
  }, [member]);

  const tabs = [
    { label: 'Dashboard', id: 'dashboard' },
    { label: 'Purchases', id: 'purchases' },
    { label: 'Activity', id: 'activity' },
    ...rewardTypeTabs,
    { label: 'Wallet Transactions', id: 'walletTransactions' },
    { label: 'Address', id: 'address' },
  ];

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <div className="position-relative mx-n4 mt-n4">
            <div
              className="profile-wid-bg profile-setting-img"
              style={{ height: 100 }}
            >
              <img src={profileBg} className="profile-wid-img" alt="" />
            </div>
          </div>
          <Row>
            <Col md={3}>
              <Card className="mt-n5">
                <CardBody className="p-4">
                  <If condition={member?._id}>
                    <Then>
                      <UserDetails
                        member={member}
                        configs={configs}
                        rewards={rewards}
                      />
                    </Then>
                  </If>
                </CardBody>
              </Card>
            </Col>

            <Col md={9}>
              <Card className="mt-md-n5">
                <CardHeader>
                  <Nav
                    className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                    role="tablist"
                  >
                    {tabs?.map((tab) => {
                      return (
                        <NavItem>
                          <NavLink
                            className={`${classnames({
                              active: activeTab === tab?.id,
                            })} text-capitalize`}
                            onClick={() => {
                              tabChange(tab?.id);
                            }}
                          >
                            {tab?.label}
                          </NavLink>
                        </NavItem>
                      );
                    })}
                  </Nav>
                </CardHeader>
                <CardBody className="p-4">
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="dashboard">
                      <Dashboard member={member} setActiveTab={setActiveTab} />
                    </TabPane>
                    {/*  Transactions */}
                    <TabPane tabId="purchases">
                      <If condition={member?._id}>
                        <TransactionTable member={member} />
                      </If>
                    </TabPane>
                    {/*  Journey  */}
                    <TabPane tabId="activity">
                      <Journey />
                    </TabPane>
                    {rewardTypeTabs?.map((rt) => {
                      return (
                        <TabPane tabId={rt?.id}>
                          <Row>
                            <Col md={4}>
                              <Card
                                className={`text-bg-dark ${member?.rewards?.[
                                  rt?.rewardTypeId
                                ]?.[member?.country]?.tierName?.toLowerCase()}`}
                                style={{ height: 'calc(100% - 1.5rem)' }}
                              >
                                <CardBody className="bg-gradient text-dark">
                                  <Row className="gap-1">
                                    <Col md={12}>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                          <span className="fs-16 fw-semibold text-capitalize me-2">
                                            {rt?.rewardTypeId?.replaceAll(
                                              '_',
                                              ' '
                                            )}
                                          </span>
                                          <p className="fs-13 mb-0">
                                            {
                                              member?.rewards?.[
                                                rt?.rewardTypeId
                                              ]?.[member?.country]?.tierName
                                            }
                                          </p>
                                          {member?.rewards?.[
                                            rt?.rewardTypeId
                                          ]?.[member?.country]
                                            ?.tierExpiryAt && (
                                            <span className="fs-10">
                                              {`Tier Expiry: ${formatDate(
                                                member?.rewards?.[
                                                  rt?.rewardTypeId
                                                ]?.[member?.country]
                                                  ?.tierExpiryAt,
                                                'MM/DD/YYYY'
                                              )}`}
                                            </span>
                                          )}
                                        </div>

                                        <Barcode
                                          value={
                                            member?.rewards?.[
                                              rt?.rewardTypeId
                                            ]?.[member?.country]?.id
                                          }
                                          background="#ffffff00"
                                          height={31}
                                          width={1.2}
                                          fontSize={15}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                            <Col md={8}>
                              <Row className="">
                                <Col md={4} className="px-2 py-0">
                                  <Card
                                    className="border"
                                    style={{ height: 'calc(100% - 1.5rem)' }}
                                  >
                                    <CardBody>
                                      <div>
                                        <p className="fw-medium text-muted mb-0 text-center pb-2 fs-16">
                                          Spendable
                                        </p>
                                        <h2 className="fs-28 card-title mb-0 text-center">
                                          <CountUp
                                            start={0}
                                            end={
                                              member?.rewards?.[
                                                rt?.rewardTypeId
                                              ]?.[member?.country]?.points
                                                ?.spendable || 0
                                            }
                                            decimals={0}
                                            duration={2}
                                            suffix="pts"
                                          />
                                        </h2>
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                                <Col md={4} className="px-2 py-0">
                                  <Card
                                    className="border"
                                    style={{ height: 'calc(100% - 1.5rem)' }}
                                  >
                                    <CardBody>
                                      <div>
                                        <p className="fw-medium text-muted mb-0 text-center pb-2 fs-16">
                                          Hold
                                        </p>
                                        <h2 className="fs-28 card-title mb-0 text-center">
                                          <CountUp
                                            start={0}
                                            end={
                                              member?.rewards?.[
                                                rt?.rewardTypeId
                                              ]?.[member?.country]?.points
                                                ?.earningHold
                                            }
                                            decimals={0}
                                            duration={2}
                                            suffix="pts"
                                          />
                                        </h2>
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                                <Col md={4} className="px-2 py-0">
                                  <Card
                                    className="border"
                                    style={{ height: 'calc(100% - 1.5rem)' }}
                                  >
                                    <CardBody>
                                      <div>
                                        <p className="fw-medium text-muted mb-0 text-center pb-2 fs-16">
                                          Redeemed
                                        </p>
                                        <h2 className="fs-28 card-title mb-0 text-center">
                                          <CountUp
                                            start={0}
                                            end={
                                              member?.rewards?.[
                                                rt?.rewardTypeId
                                              ]?.[member?.country]?.points
                                                ?.redeemed || 0
                                            }
                                            decimals={0}
                                            duration={2}
                                            suffix="pts"
                                          />
                                        </h2>
                                      </div>
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <RewardTransactionTable
                            rewardTypeId={rt?.rewardTypeId}
                            rewardId={rt?.rewardId}
                            member={member}
                          />
                        </TabPane>
                      );
                    })}

                    {/*  Address */}
                    <TabPane tabId="walletTransactions">
                      <Address />
                    </TabPane>
                    <TabPane tabId="address">
                      <Address />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Profile;
